import Loader from "components/Loader/Loader";
import Context from "context/Global";
import moment from "moment";
import Papa from "papaparse";
import React, {
    Fragment,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";
import Api from "services/Api/Api";
import styled from "styled-components/macro";

let Container = styled.div`
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1em;

    > .dropInvoices {
        border: 2px dashed #ddd;
        color: #aaa;
        font-size: 2em;
        border-radius: 1em;
        width: 50%;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .dataItems {
        display: flex;
        flex-direction: row;

        > .divider {
            width: 1px;
            height: 32px;
            background: #000;
            margin-right: 1.2em;
        }

        > .item {
            display: flex;
            align-items: center;
            margin-right: 1.2em;
            position: relative;

            &:last-child {
                color: rgba(0, 180, 80, 1);
                font-weight: bold;
                padding: 0 0.5em;
                border-radius: 200px;
                font-size: 1.2em;
            }

            &:nth-last-child(2) {
                font-size: 1.2em;
                > .icon {
                    height: 24px;
                    width: 24px;
                }
            }

            > .hover-tooltip {
                color: #000;
                position: absolute;
                font-size: 1rem;
                bottom: 0;
                padding-bottom: 32px;
                white-space: nowrap;
                opacity: 0;
                pointer-events: none;
                justify-content: center;
                align-items: center;
                width: 100%;
                display: none;
                z-index: 100;

                > .text {
                    background: #fff;
                    border-radius: 5px;
                    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
                    padding: 4px 8px;
                }
            }

            &:hover {
                > .hover-tooltip {
                    display: flex;
                    opacity: 1;
                    pointer-events: all;
                }
            }

            > .icon {
                height: 16px;
                width: 16px;
                display: flex;
                justify-content: center;
                align-items: center;

                > svg {
                    width: 100%;
                    height: 100%;
                }
            }

            > .text {
                font-size: 0.8em;
                margin-left: 0.5em;
            }
        }
    }

    > .invoices {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        padding-top: 2rem;
        padding: 2rem 1rem;

        .dataTable {
            tr:last-child {
                td {
                    padding-top: 1rem;
                    font-size: 1.2rem;
                }
            }
            th,
            td {
                text-align: right;
                padding-right: 16px;

                &:nth-child(4) {
                    border-left: 1px solid rgba(0, 0, 0, 0.5);
                    padding-left: 16px;
                }

                &:first-child {
                    text-align: left;
                }
            }

            td {
                &:last-child {
                    color: rgba(0, 180, 80, 1);
                    font-weight: bold;
                }

                &:nth-last-child(2) {
                    font-weight: bold;
                }
            }
        }

        > .invoice {
            display: flex;
            align-items: center;
            padding: 0.2em 1rem;

            > .title {
                padding-right: 1rem;
            }
        }
    }

    > .customers {
        padding: 2em 0;
        width: 100%;

        > .customer {
            display: flex;
            flex-direction: column;

            > .summary {
                padding: 0.5rem 1rem 1rem;
            }

            > .name {
                font-size: 2em;
                padding: 0 1rem;
                display: flex;
                align-items: center;

                > .invoice {
                    margin-left: 1em;
                }
            }

            > .orders {
                display: flex;
                flex-direction: column;

                > .order {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 0.5vw 1rem;

                    &:hover {
                        background: rgba(0, 0, 0, 0.05);
                    }

                    > .information {
                        display: flex;
                        flex-direction: column;
                    }

                    > .price {
                        display: flex;
                        flex-direction: row;
                        padding-left: 1em;
                        font-size: 2em;
                        margin-left: auto;

                        > .amount {
                        }

                        > .change {
                            padding-left: 1em;

                            &.is-negative {
                                color: rgba(200, 100, 100, 1);
                                font-weight: bold;
                            }

                            &.is-positive {
                                color: rgba(100, 200, 100, 1);
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }
    }

    > .deviations {
        padding: 0 1em;
        width: 100%;

        > .title {
            font-size: 1.6em;
        }

        > .numbers {
            display: flex;
            flex-direction: column > .number {

            }
        }
    }

    > .notFound {
        padding: 0 1rem;
        width: 100%;
        margin-bottom: 2rem;

        > .title {
            font-size: 1.6em;
        }

        > .grid {
            display: grid;
            grid-template-columns: auto auto auto auto;
            width: fit-content;

            > .cell {
                padding-right: 1rem;

                &.title {
                    font-weight: bold;
                }
            }
        }
    }

    > .preview {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 10%;
        background: rgba(0, 0, 0, 0.3);
        z-index: 1000;
        overflow-y: auto;

        > .imageContainer {
            background: #fff;
            padding: 2%;
            width: 100%;
            cursor: pointer;

            > img {
                width: 100%;
            }
        }
    }
`;

function formatPrice(amount, unit = "SEK") {
    amount = parseFloat(amount).toFixed(2);
    return (
        (typeof amount === "string"
            ? amount.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            : 0) +
        " " +
        unit
    );
}

function View(props) {
    const context = useContext(Context);
    const [customers, setCustomers] = useState([]);
    const [missingOrders, setMissingOrders] = useState([]);
    const [alreadyInvoicedTrackingNumbers, setAlreadyInvoicedTrackingNumbers] =
        useState([]);
    const [invoicedCustomers, setInvoicedCustomers] = useState([]);
    const [invoicingCustomers, setInvoicingCustomers] = useState([]);
    const [rawInvoice, setRawInvoice] = useState(null);
    const [parsedInvoice, setParsedInvoice] = useState(null);
    const [parsedInvoices, setParsedInvoices] = useState([]);
    const [dndMessage, setDndMessage] = useState(null);

    const [totalInvoicesPrice, setTotalInvoicesPrice] = useState(0);
    const [totalInvoicesEarnings, setTotalInvoicesEarnings] = useState(0);
    const [totalPartnerCost, setTotalPartnerCost] = useState(0);
    const [totalCostVat, setTotalCostVat] = useState(0);
    const [totalCostNoVat, setTotalCostNoVat] = useState(0);

    const [totalCount, setTotalCount] = useState(0);
    const [totalInvoiceValue, setTotalInvoiceValue] = useState(0);
    const [totalHits, setTotalHits] = useState(0);
    const [totalTransportCost, setTotalTransportCost] = useState(0);
    const [totalSurchargeCost, setTotalSurchargeCost] = useState(0);
    const [totalSurchargableCost, setTotalSurchargableCost] = useState(0);

    const [specificationPreview, setSpecificationPreview] = useState(null);
    const [loadingSpecification, setLoadingSpecification] = useState(false);
    const [addedInvoices, setAddedInvoices] = useState([]);
    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            if (
                file.name.substr(-4).toLowerCase() === ".csv" ||
                file.name.substr(-4).toLowerCase() === ".txt"
            ) {
                setDndMessage(null);
                const reader = new FileReader();

                reader.onabort = () =>
                    console.error("file reading was aborted");
                reader.onerror = () => console.error("file reading has failed");
                reader.onload = () => {
                    let csvText = reader.result;

                    if (
                        csvText.indexOf('"Billing Country/Territory,""') === 0
                    ) {
                        // Some fedex invoices are invalid so we need to fix them.
                        csvText = csvText.replace(
                            /"Billing Country\/Territory,""/gm,
                            '"Billing Country/Territory",""',
                        );
                        csvText = csvText.replace(/"SE,""/gm, '"SE",""');
                        csvText = csvText.replace(/,"$/gm, "");
                        csvText = csvText.replace(/(")\1+/gm, '"');
                    }
                    if (
                        csvText.indexOf("2.1") === 0 ||
                        csvText.indexOf('"2.1') === 0
                    ) {
                        // Some UPS invoices are invalid so we need to fix them.
                        csvText = csvText.replace(/(")\1+/gm, '"');
                        csvText = csvText.replace(/^"(.*)"$/gm, "$1");
                    }

                    let delimiter = ",";
                    if (csvText.substr(0, 17) === "Debet/Kredit-kod;") {
                        delimiter = ";";
                    }
                    let rows = Papa.parse(csvText, {
                        delimiter: delimiter,
                    });

                    setRawInvoice({
                        name: file.name,
                        rows: rows.data,
                    });
                };
                reader.readAsText(file, "ISO-8859-1");
            } else {
                setDndMessage("Endast CSV-filer går att använda.");
            }
        });
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    useEffect(() => {
        if (
            context.user.administrator ||
            (context.user.brand && context.user.brand.id)
        ) {
            // loadInvoices();
        } else {
            props.history.replace("/admin");
        }
    }, []);

    useEffect(() => {
        if (rawInvoice && rawInvoice.rows) {
            try {
                let invoice = null;
                if (rawInvoice.rows[0][0] === "Account Number") {
                    invoice = parseTNTData(rawInvoice);
                } else if (rawInvoice.rows[0][0] === "Debet/Kredit-kod") {
                    invoice = parseDHLData(rawInvoice);
                } else if (
                    rawInvoice.rows[0][0] === "Billing Country/Territory"
                ) {
                    invoice = parseFedexData(rawInvoice);
                } else if (parseInt(rawInvoice.rows[0][0]) > 0) {
                    invoice = parseUPSData(rawInvoice);
                } else {
                    console.error("Cannot identify data structure.");
                }

                setParsedInvoice(invoice);
                // getInvoiceReport(orders, rawInvoice.name);
            } catch (error) {
                setDndMessage("Det gick inte att läsa in filen.");
                console.error(error);
            }
        }
    }, [rawInvoice]);

    // async function loadInvoices() {
    // 	setOrders(await Api.getOrdersReadyForInvoice());
    // }

    function parseUPSOrderRow(row) {
        // Label "Adresskorrigering": When row[34] == "ADJ" and row[35] == "ADC"
        // Label "Privatleverans": When row[34] == "ADJ" and row[35] == "RADJ"
        // Label "Fraktkostnad": When row[34] == "SHP" and row[43] == "FRT"
        // Label "Bränsle": When row[34] == "SHP" and row[43] == "FSC"
        // Add tax if row[49] === 1
        // Ignore: When row[43] == "INF" || "EXM"
        // Ignore: When row[43] == "TAX"

        // row[34] = "ADJ", "SHP";
        // row[35] = "ADC" means address correction - label it as "Adresskorrigering"
        // row[35] = "RADJ" and other shit.. RADJ is the only one interesting.
        // row[43] = "TAX" means that it is a tax, "FRT" means it's a shipment, "FSC" means it is fuel

        let type = "extra";
        let addVat = false;
        let label = row[45];

        if (row[34] === "ADJ" && row[35] === "ADC") {
            label = "Adresskorrigering";
        } else if (row[34] === "ADJ" && row[35] === "RADJ") {
            label = "Privatleverans";
        } else if (
            row[34] === "ADJ" &&
            row[43] === "FRT" &&
            row[45] === "Transport" &&
            row[174]
        ) {
            label = row[174];
        } else if (["SHP", "RTN"].indexOf(row[34]) >= 0 && row[43] === "FRT") {
            type = "transport";
        } else if (["SHP", "RTN"].indexOf(row[34]) >= 0 && row[43] === "FSC") {
            label = "Bränsle";
        }

        if (["TAX", "INF", "EXM"].indexOf(row[43]) >= 0) {
            return null;
        }

        if (row[49] == 1) {
            addVat = true;
        }

        if (type === "transport") {
            return {
                type: type,
                trackingNumber: row[13],
                data: {
                    transporter: "UPS",
                    trackingNumber: row[13],
                    transportCost: {
                        net: parseFloat(row[52]),
                    },
                    price: {
                        net: 0,
                        addVat: addVat,
                    },
                    label: label,
                    billedWeight: row[28],
                    extras: [],
                    reference: row[15],
                    senderCompany: row[67],
                    senderCountry: row[73],
                    receiverCompany: row[75],
                    receiverCountry: row[81],
                    pickupDate: moment(row[11]).format("YYYY-MM-DD"), // We don't have the pickup date so set to same as delivery
                    deliveryDate: moment(row[11]).format("YYYY-MM-DD"),
                },
            };
        } else {
            if (label.indexOf("Hï¿½gsï¿½songsavgift") >= 0) {
                label = "Högsäsongsavgift";
            }
            if (label.indexOf("Avgift fï¿½r fï¿½rbjuden vara") >= 0) {
                label = "Avgift för förbjuden vara";
            }
            if (label.indexOf("Returer ") === 0) {
                label = label.substr(8);
            }
            let addSurcharge = false;
            let additionalCost = false;
            if (["Bränsle", "Returer Bränsletillägg"].indexOf(label) >= 0) {
                addSurcharge = true;
            }

            return {
                type: "extra",
                trackingNumber: row[13],
                shipment: {
                    transporter: "UPS",
                    trackingNumber: row[13],
                    transportCost: {
                        net: 0,
                        vat: 0,
                        total: 0,
                    },
                    price: {
                        net: 0,
                        vat: 0,
                        total: 0,
                    },
                    billedWeight: row[28],
                    reference: row[15],
                    senderCompany: row[67],
                    senderCountry: row[73],
                    receiverCompany: row[75],
                    receiverCountry: row[81],
                    pickupDate: moment(row[11]).format("YYYY-MM-DD"), // We don't have the pickup date so set to same as delivery
                    deliveryDate: moment(row[11]).format("YYYY-MM-DD"),
                },
                extras: {
                    title: label,
                    addVat: addVat,
                    additionalCost: additionalCost,
                    netPrice: parseFloat(row[52]),
                    vat: 0,
                    total: 0,
                    surcharge: addSurcharge,
                },
            };
        }
    }

    function parseUPSData(invoiceData) {
        let invoice = {
            name: invoiceData.name,
            orderCount: 0,
            totalCost: 0,
            orders: [],
        };

        let orders = {};

        for (const row of invoiceData.rows) {
            if (!row[13]) {
                continue;
            }
            if (row[13].indexOf("1Z") != 0 && !row[20].indexOf("1Z")) {
                row[13] = row[20];
            }
            let order = parseUPSOrderRow(row);

            if (order) {
                if (!orders[order.trackingNumber]) {
                    invoice.orderCount++;
                    if (order.type === "transport") {
                        orders[order.trackingNumber] = order.data;
                    } else {
                        orders[order.trackingNumber] = {
                            ...order.shipment,
                            extras: [order.extras],
                        };
                    }
                } else {
                    if (order.type === "transport") {
                        orders[order.trackingNumber] = {
                            ...order.data,
                            extras: orders[order.trackingNumber].extras,
                        };
                    } else {
                        orders[order.trackingNumber].extras.push(order.extras);
                    }
                }
            }
        }

        Object.keys(orders).forEach((key) => {
            let order = orders[key];

            order.price.net = 0;
            if (order.transportCost) {
                order.price.net += order.transportCost.net;
            }
            order.extras.forEach((extra) => {
                order.price.net += extra.netPrice;
            });

            order.price.net = Math.ceil(order.price.net);

            order.extras = order.extras.filter((extra) => {
                if (extra.addVat) {
                    extra.vat = extra.netPrice * 0.25;
                    extra.total = extra.netPrice + extra.vat;
                } else {
                    extra.vat = 0;
                    extra.total = extra.netPrice;
                }
                return extra;
            });

            invoice.totalCost += order.price.net;

            invoice.orders.push(order);
        });

        return invoice;
    }

    function parseTNTData(invoiceData) {
        let invoice = {
            name: invoiceData.name,
            orderCount: 0,
            totalCost: 0,
            orders: [],
        };

        for (let i = 1; i < invoiceData.rows.length; i++) {
            if (!invoiceData.rows[i][13]) {
                continue;
            }
            let orderPrice = {
                net: parseFloat(invoiceData.rows[i][23]),
            };
            orderPrice.vat = parseFloat(invoiceData.rows[i][24]) || 0;
            orderPrice.total = orderPrice.net + orderPrice.vat;
            invoice.orderCount++;
            invoice.totalCost += orderPrice.net;
            invoice.orders.push({
                transporter: "TNT",
                senderCompany: invoiceData.rows[i][12],
                senderCountry: null,
                receiverCompany: invoiceData.rows[i][7],
                receiverCountry: invoiceData.rows[i][11],
                pickupDate: moment(invoiceData.rows[i][16], "DD/MM/YY").format(
                    "YYYY-MM-DD",
                ),
                deliveryDate: moment(
                    invoiceData.rows[i][16],
                    "DD/MM/YY",
                ).format("YYYY-MM-DD"),
                reference: invoiceData.rows[i][14],
                trackingNumber: invoiceData.rows[i][13],
                billedWeight: invoiceData.rows[i][17],
                extras: [],
                transportCost: orderPrice,
                price: orderPrice,
            });
        }
        return invoice;
    }

    function parseFedexData(invoiceData) {
        let invoice = {
            name: invoiceData.name,
            orderCount: 0,
            totalCost: 0,
            orders: [],
        };

        for (let i = 1; i < invoiceData.rows.length; i++) {
            if (!invoiceData.rows[i][16]) {
                continue;
            }
            invoice.orderCount++;

            let loop = true;
            let columnIndex = 56;
            let currentData = {};
            let extras = [];
            let price = {
                net: 0,
                vat: 0,
                total: 0,
            };
            let transportCost = {
                net: 0,
                vat: 0,
                total: 0,
            };
            let addVat = false;

            while (loop) {
                if (!invoiceData.rows[0][columnIndex]) {
                    loop = false;
                } else {
                    if (
                        invoiceData.rows[0][columnIndex] ===
                        "Air Waybill Charge Label"
                    ) {
                        currentData = {
                            title: invoiceData.rows[i][columnIndex]
                                ? decodeURIComponent(
                                      escape(invoiceData.rows[i][columnIndex]),
                                  )
                                : null,
                            netPrice: invoiceData.rows[i][columnIndex + 1]
                                ? parseFloat(
                                      invoiceData.rows[i][
                                          columnIndex + 1
                                      ].replace(/,/g, ""),
                                  )
                                : null,
                        };
                        if (currentData.title === "Bränsleavgift") {
                            currentData.surcharge = true;
                        }

                        if (
                            currentData.netPrice &&
                            currentData.title !== "Sverige moms 25.%"
                        ) {
                            price.net += parseFloat(currentData.netPrice);
                        }

                        // Calculate the transport cost
                        if (currentData.title === "Transportavgift") {
                            transportCost.net +=
                                Math.round(currentData.netPrice * 100) / 100;
                        } else if (currentData.title === "Rabatt") {
                            transportCost.net +=
                                Math.round(currentData.netPrice * 100) / 100;
                        } else if (currentData.title === "Sverige moms 25.%") {
                            transportCost.vat =
                                Math.round(currentData.netPrice * 100) / 100;
                            price.vat += transportCost.vat;
                            addVat = true;
                        }

                        if (
                            currentData.title &&
                            [
                                "Transportavgift",
                                "Rabatt",
                                "Sverige moms 25.%",
                            ].indexOf(currentData.title) < 0
                        ) {
                            extras.push(currentData);
                            currentData = {};
                        }
                    }

                    currentData = {};
                }
                columnIndex++;
            }

            extras = extras.map((extra) => {
                extra.vat = extra.vat || 0;
                if (addVat) {
                    extra.vat = extra.netPrice * 0.25;
                }
                price.vat += extra.vat;
                extra.total = extra.netPrice + extra.vat;
                return extra;
            });

            price.total = price.net + price.vat;
            transportCost.total = transportCost.net + transportCost.vat;

            invoice.totalCost += price.net;

            invoice.orders.push({
                transporter: "Fedex",
                label: invoiceData.rows[i][29].trim(),
                senderCompany:
                    invoiceData.rows[i][38].trim() ||
                    invoiceData.rows[i][39].trim(),
                senderCountry: invoiceData.rows[i][46].trim(),
                receiverCompany:
                    invoiceData.rows[i][47].trim() ||
                    invoiceData.rows[i][48].trim(),
                receiverCountry: invoiceData.rows[i][55].trim(),
                packageCount: parseInt(invoiceData.rows[i][32].trim()),
                pickupDate: moment(invoiceData.rows[i][25].trim()).format(
                    "YYYY-MM-DD",
                ),
                deliveryDate: moment(invoiceData.rows[i][21].trim()).format(
                    "YYYY-MM-DD",
                ),
                reference: invoiceData.rows[i][18].trim(),
                trackingNumber: invoiceData.rows[i][16],
                billedWeight: parseFloat(invoiceData.rows[i][33]),
                transportCost: transportCost,
                price: price,
                extras: extras,
            });
        }
        return invoice;
    }

    function parseDHLData(invoiceData) {
        let invoice = {
            name: invoiceData.name,
            orderCount: 0,
            totalCost: 0,
            orders: [],
        };

        for (let i = 1; i < invoiceData.rows.length; i++) {
            if (!invoiceData.rows[i][35]) {
                continue;
            }
            invoice.orderCount++;
            let billedWeight = parseFloat(invoiceData.rows[i][50]);
            // let weight = parseFloat(invoiceData.rows[i][52]) || parseFloat(invoiceData.rows[i][51]) || null;
            // let volume = parseFloat(invoiceData.rows[i][54]) || parseFloat(invoiceData.rows[i][53]) || null;
            // let loadingMetres = parseFloat(invoiceData.rows[i][56]) || parseFloat(invoiceData.rows[i][55]) || null;
            let addVat = parseInt(invoiceData.rows[i][121]) !== 0;

            let orderPrice = {
                net: parseFloat(invoiceData.rows[i][122].replace(",", ".")),
                vat: 0,
                total: 0,
            };
            if (addVat) {
                orderPrice.vat = orderPrice.net * 0.25;
            }
            orderPrice.total = orderPrice.net + orderPrice.vat;

            let extras = [];

            if (invoiceData.rows[i][125]) {
                let price = parseFloat(
                    invoiceData.rows[i][125].replace(",", "."),
                );
                let vat = addVat ? price * 0.25 : 0;
                extras.push({
                    title: "Drivmedelstillägg / -justering",
                    netPrice: price,
                    vat: vat,
                    total: price + vat,
                    surcharge: true,
                });
            }
            if (invoiceData.rows[i][137]) {
                let price = parseFloat(
                    invoiceData.rows[i][137].replace(",", "."),
                );
                let vat = addVat ? price * 0.25 : 0;
                extras.push({
                    title: "Gotlandstillägg",
                    netPrice: price,
                    vat: vat,
                    total: price + vat,
                    surcharge: true,
                });
            }
            if (invoiceData.rows[i][140]) {
                let price = parseFloat(
                    invoiceData.rows[i][140].replace(",", "."),
                );
                let vat = addVat ? price * 0.25 : 0;
                extras.push({
                    title: "Storstads- / Ortstillägg",
                    netPrice: price,
                    vat: vat,
                    total: price + vat,
                    surcharge: true,
                });
            }

            let loop = true;
            let titleCellIndex = 147;
            while (loop) {
                if (!invoiceData.rows[i][titleCellIndex]) {
                    loop = false;
                } else {
                    if (parseFloat(invoiceData.rows[i][titleCellIndex + 1])) {
                        const ignoreList = [
                            "Exportspedition 3:e land",
                            "Trafikstörningstillägg",
                            "Trafikstï¿½rningstillï¿½gg",
                            "Marpol tillägg",
                            "Marpol tillï¿½gg",
                        ];
                        if (
                            invoiceData.rows[i][titleCellIndex]
                                .toLowerCase()
                                .indexOf("vägskatt") < 0 &&
                            invoiceData.rows[i][titleCellIndex]
                                .toLowerCase()
                                .indexOf("valutatill") < 0
                        ) {
                            if (
                                ignoreList.indexOf(
                                    invoiceData.rows[i][titleCellIndex],
                                ) < 0
                            ) {
                                let price = parseFloat(
                                    invoiceData.rows[i][
                                        titleCellIndex + 1
                                    ].replace(",", "."),
                                );
                                let vat = addVat ? price * 0.25 : 0;
                                let noSurchargeTitles = [
                                    "Ändr av transportuppdrag",
                                    "Felaktig sändningsuppgift",
                                    "Leveranshinder",
                                ];
                                extras.push({
                                    title: invoiceData.rows[i][titleCellIndex],
                                    netPrice: price,
                                    vat: vat,
                                    total: price + vat,
                                    surcharge:
                                        noSurchargeTitles.indexOf(
                                            invoiceData.rows[i][titleCellIndex],
                                        ) < 0,
                                });
                            }
                        }
                    }
                    titleCellIndex += 5;
                }
            }

            let transportCost = {
                net: orderPrice.net,
                vat: 0,
                total: 0,
            };
            invoice.totalCost += orderPrice.net;

            extras.forEach((extra) => {
                transportCost.net -= extra.netPrice;
            });

            transportCost.vat = addVat ? transportCost.net * 0.25 : 0;
            transportCost.total = transportCost.net + transportCost.vat;

            invoice.orders.push({
                transporter: "DHL",
                senderCompany: invoiceData.rows[i][70],
                senderCountry: invoiceData.rows[i][75],
                receiverCompany: invoiceData.rows[i][80],
                receiverCountry: invoiceData.rows[i][85],
                pickupDate: moment(invoiceData.rows[i][39], "YYYYMMDD").format(
                    "YYYY-MM-DD",
                ),
                deliveryDate: moment(invoiceData.rows[i][2], "YYYYMMDD")
                    .subtract(1, "day")
                    .format("YYYY-MM-DD"),
                reference: invoiceData.rows[i][78],
                trackingNumber: invoiceData.rows[i][35],
                billedWeight: billedWeight,
                // weight: weight,
                // loadingMetres: loadingMetres,
                // volume: volume,
                price: orderPrice,
                transportCost: transportCost,
                extras: extras,
            });
        }
        return invoice;
    }

    useEffect(() => {
        if (!parsedInvoice) {
            return;
        }

        calculateStuff(parsedInvoice).then((result) => {
            if (result) {
                parsedInvoice.data = result.invoiceData;
                let invoiceList = []
                    .concat(parsedInvoices)
                    .concat(parsedInvoice);
                invoiceList.sort((a, b) => {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
                setParsedInvoices(invoiceList);
                setCustomers(result.customers);
            }
        });
    }, [parsedInvoice]);

    async function calculateStuff(parsedInvoice) {
        let report = await Api.getInvoiceReport({
            orders: parsedInvoice.orders,
        }).catch((error) => {
            setDndMessage("Det gick inte att läsa in filen.");
            console.error(error);
        });

        if (!report) {
            return;
        }

        let mergedCustomers = [];
        setMissingOrders([
            ...new Set(missingOrders.concat(report.missingOrders)),
        ]);
        setAlreadyInvoicedTrackingNumbers([
            ...new Set(
                alreadyInvoicedTrackingNumbers.concat(report.alreadyInvoiced),
            ),
        ]);
        report.customers.forEach((customer) => {
            let duplicate = customers.find((c) => {
                return c.id === customer.id;
            });
            if (duplicate) {
                customer.orders.forEach((order) => {
                    let duplicateOrder = duplicate.orders.find((o) => {
                        return o.id === order.id;
                    });
                    if (!duplicateOrder) {
                        duplicate.orders.push(order);
                    }
                });
                mergedCustomers.push(duplicate);
            } else {
                mergedCustomers.push(customer);
            }
        });

        customers.forEach((oldCustomer) => {
            let found = report.customers.find((c) => {
                return c.id === oldCustomer.id;
            });
            if (!found) {
                mergedCustomers.push(oldCustomer);
            }
        });

        let totInvoicesPrice = 0;
        let totInvoicesEarnings = 0;
        let totPartnerCost = 0;
        let totCostVat = 0;
        let totCostNoVat = 0;
        let totCount = 0;
        let totInvoiceValue = 0;
        let totHits = 0;
        let totTransportCost = 0;
        let totSurchargeCost = 0;
        let totSurchargableCost = 0;

        mergedCustomers.forEach((customer) => {
            let customerPrice = 0;
            let customerSurcharge = 0;
            let earnings = 0;
            let extrasCost = 0;
            let partnerCost = 0;
            let totalCost = 0;
            let transportCost = 0;
            customer.orders.forEach((order) => {
                if (order.price) {
                    customerPrice += order.price.customerPrice;
                    customerSurcharge += order.price.customerSurcharge;
                    earnings += order.price.earnings;
                    extrasCost += order.price.extrasCost;
                    partnerCost += order.price.partnerCost;
                    totalCost += order.price.totalCost;
                    transportCost += order.price.transportCost;
                }
            });

            customer.customerPrice = customerPrice;
            customer.customerSurcharge = customerSurcharge;
            customer.earnings = earnings;
            customer.extrasCost = extrasCost;
            customer.partnerCost = partnerCost;
            customer.totalCost = totalCost;
            customer.transportCost = transportCost;
        });

        let invoiceData = {
            orderCount: 0,
            customerPrice: 0,
            customerSurcharge: 0,
            earnings: 0,
            extrasCost: 0,
            partnerCost: 0,
            totalCost: 0,
            totalCostVat: 0,
            totalCostNoVat: 0,
            transportCost: 0,
            surchargeableCosts: 0,
            totalEarnings: 0,
            currency: "SEK",
        };

        mergedCustomers.forEach((customer) => {
            customer.orders.forEach((order) => {
                if (!order.invoiceName) {
                    order.invoiceName = parsedInvoice.name;
                }
                if (order.invoiceName == parsedInvoice.name) {
                    invoiceData.orderCount++;
                    invoiceData.customerPrice += order.price.customerPrice;
                    invoiceData.customerSurcharge +=
                        order.price.customerSurcharge;
                    invoiceData.earnings += order.price.earnings;
                    invoiceData.extrasCost += order.price.extrasCost;
                    invoiceData.partnerCost += order.price.partnerCost;
                    invoiceData.totalCost += order.price.totalCost;
                    invoiceData.totalCostVat += order.price.vat
                        ? order.price.totalCost
                        : 0;
                    invoiceData.totalCostNoVat += !order.price.vat
                        ? order.price.totalCost
                        : 0;
                    invoiceData.transportCost += order.price.transportCost;
                    invoiceData.surchargeableCosts +=
                        order.price.surchargeableCosts;
                }
                totInvoicesPrice += order.price.customerPrice;
                totInvoicesEarnings += order.price.earnings;
                totPartnerCost += order.price.partnerCost;
                totCostVat += order.price.vat ? order.price.totalCost : 0;
                totCostNoVat += !order.price.vat ? order.price.totalCost : 0;
            });
        });

        mergedCustomers.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            } else if (a.name > b.name) {
                return 1;
            }
            return 0;
        });

        // totCount += parsedInvoice.orderCount;
        // totHits++;
        // totInvoiceValue += order.price.customerPrice;
        // totTransportCost += order.price.transportCost;
        // totSurchargeCost += order.price.extrasCost;
        // totSurchargableCost += order.price.surchargeableCosts;

        setTotalInvoicesPrice(totInvoicesPrice);
        setTotalInvoicesEarnings(totInvoicesEarnings);
        setTotalPartnerCost(totPartnerCost);
        setTotalCostVat(totCostVat);
        setTotalCostNoVat(totCostNoVat);
        setTotalCount((previousValue) => {
            return parsedInvoice.orderCount + previousValue;
        });
        setTotalInvoiceValue((previousValue) => {
            return parsedInvoice.totalCost + previousValue;
        });
        setTotalHits((previousValue) => {
            return invoiceData.orderCount + previousValue;
        });
        setTotalTransportCost((previousValue) => {
            return invoiceData.transportCost + previousValue;
        });
        setTotalSurchargeCost((previousValue) => {
            return invoiceData.extrasCost + previousValue;
        });
        setTotalSurchargableCost((previousValue) => {
            return invoiceData.surchargeableCosts + previousValue;
        });

        return {
            invoiceData: invoiceData,
            customers: mergedCustomers,
        };
    }

    async function createInvoice(customer) {
        await Api.createInvoice({
            customerId: customer.id,
            orders: customer.orders,
        });
    }

    async function previewInvoice(customer) {
        setLoadingSpecification(true);
        setSpecificationPreview(
            await Api.previewInvoice({
                customerId: customer.id,
                orders: customer.orders,
            }),
        );
        setLoadingSpecification(false);
    }

    // Consignment Number
    // Sender
    // Receiver

    // if(!orders) {
    // 	return <Loader />;
    // }

    function getPercentage(total, cost) {
        return Math.round((1 / (cost / total)) * 100);
    }

    function getObjectKeysInOrder(invoices) {
        let keys = Object.keys(invoices);
        keys.sort();
        return keys;
    }

    return (
        <Container>
            <div className="dropInvoices" {...getRootProps()}>
                <input {...getInputProps()} />
                {isDragActive ? (
                    <p>Släpp filerna här</p>
                ) : dndMessage ? (
                    dndMessage
                ) : (
                    <p>Fakturaunderlag</p>
                )}
            </div>
            <div className="invoices">
                <table className="dataTable">
                    <thead>
                        <tr>
                            <th>Filnamn</th>
                            <th>Antal</th>
                            <th>Faktura</th>
                            <th>Träffar</th>
                            <th>Transportkostn.</th>
                            <th>Tilläggskostn.</th>
                            <th>Prov.grundad kostn.</th>
                            <th>Partnerkostn.</th>
                            <th>Tot. momspliktig</th>
                            <th>Tot. ej momspliktig</th>
                            <th>Kundens pris</th>
                            <th>Vinst</th>
                        </tr>
                    </thead>
                    <tbody>
                        {parsedInvoices.map((invoice, index) => {
                            return (
                                <tr key={invoice.name}>
                                    <td>{invoice.name}</td>
                                    <td>{invoice.orderCount}</td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.totalCost * 100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                    <td>{invoice.data.orderCount}</td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.data.transportCost *
                                                    100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.data.extrasCost * 100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.data
                                                    .surchargeableCosts * 100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.data.partnerCost * 100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.data.totalCostVat * 100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.data.totalCostNoVat *
                                                    100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.data.customerPrice *
                                                    100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                    <td>
                                        {formatPrice(
                                            Math.round(
                                                invoice.data.earnings * 100,
                                            ) / 100,
                                            invoice.data.currency,
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <td>{totalCount}</td>
                            <td>{formatPrice(totalInvoiceValue)}</td>
                            <td>{totalHits}</td>
                            <td>{formatPrice(totalTransportCost)}</td>
                            <td>{formatPrice(totalSurchargeCost)}</td>
                            <td>{formatPrice(totalSurchargableCost)}</td>
                            <td>{formatPrice(totalPartnerCost)}</td>
                            <td>{formatPrice(totalCostVat)}</td>
                            <td>{formatPrice(totalCostNoVat)}</td>
                            <td>{formatPrice(totalInvoicesPrice)}</td>
                            <td>{formatPrice(totalInvoicesEarnings)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="customers">
                {customers.map((customer) => {
                    return (
                        <div className="customer" key={customer.id}>
                            <div className="name">
                                <Link to={`/admin/customers/${customer.id}`}>
                                    {customer.name}
                                </Link>
                                <div
                                    className="invoice c-button c-button--raised"
                                    onClick={() => {
                                        previewInvoice(customer);
                                    }}
                                >
                                    Förhandsgranska
                                </div>
                                {invoicedCustomers.indexOf(customer.id) < 0 && (
                                    <div
                                        className="invoice c-button c-button--raised"
                                        disabled={
                                            invoicingCustomers.indexOf(
                                                customer.id,
                                            ) >= 0
                                        }
                                        onClick={async () => {
                                            let confirmed = window.confirm(
                                                "Skapa faktura för " +
                                                    customer.name +
                                                    "?",
                                            );
                                            if (confirmed) {
                                                setInvoicingCustomers(
                                                    invoicingCustomers.concat([
                                                        customer.id,
                                                    ]),
                                                );
                                                await createInvoice(customer);
                                                setInvoicedCustomers(
                                                    invoicedCustomers.concat([
                                                        customer.id,
                                                    ]),
                                                );
                                            }
                                        }}
                                    >
                                        Fakturera
                                    </div>
                                )}
                            </div>
                            <div className="summary">
                                <div className="dataItems">
                                    <div className="item">
                                        <div className="hover-tooltip">
                                            <div className="text">
                                                Antalet försändelser
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14z"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text">
                                            {customer.orders.length}
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="hover-tooltip">
                                            <div className="text">
                                                Transportkostnad
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <svg
                                                clipRule="evenodd"
                                                fillRule="evenodd"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M5 18h-1c-.552 0-1-.448-1-1v-2h12v-9h4.667c1.117 0 1.6.576 1.936 1.107.594.94 1.536 2.432 2.109 3.378.188.312.288.67.288 1.035v4.48c0 1.121-.728 2-2 2h-1c0 1.656-1.344 3-3 3s-3-1.344-3-3h-4c0 1.656-1.344 3-3 3s-3-1.344-3-3zm3-1.2c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm10 0c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm-10-8.8h-8v-2h8v-1h-5v-1c0-.552.448-1 1-1h9c.552 0 1 .448 1 1v10h-11v-3h-2v-2h7v-1zm9 0v3h4.715l-1.427-2.496c-.178-.312-.509-.504-.868-.504h-2.42z"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text">
                                            {formatPrice(
                                                Math.round(
                                                    customer.transportCost *
                                                        100,
                                                ) / 100,
                                                customer.currency,
                                            )}
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="hover-tooltip">
                                            <div className="text">
                                                Partnerkostnad
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M11.329 19.6c-.185.252-.47.385-.759.385-.194 0-.389-.06-.558-.183-.419-.309-.509-.896-.202-1.315l1.077-1.456c.308-.417.896-.508 1.315-.199.421.306.511.895.201 1.313l-1.074 1.455zm-.825-2.839c.308-.418.217-1.007-.201-1.316-.421-.308-1.008-.216-1.317.203l-1.073 1.449c-.309.419-.217 1.009.202 1.317.417.307 1.007.218 1.315-.202l1.074-1.451zm-1.9-1.388c.309-.417.217-1.007-.203-1.315-.418-.307-1.007-.216-1.314.202l-1.083 1.461c-.308.419-.209.995.209 1.304.421.308 1 .229 1.308-.19l1.083-1.462zm-1.898-1.386c.308-.419.219-1.007-.203-1.315-.419-.309-1.007-.218-1.315.201l-1.075 1.451c-.308.418-.217 1.008.202 1.315.419.307 1.008.218 1.315-.202l1.076-1.45zm17.294-8.438s-1.555.301-2.667.479c-2.146.344-4.144-.416-6.361-1.562-.445-.229-.957-.466-1.458-.466-.461 0-.913.209-1.292.639-1.366 1.547-2.16 2.915-3.785 3.864-.801.468.14 1.934 1.86 1.331.878-.308 1.736-.895 2.706-1.677.762-.615 1.22-.524 1.879.135 1.238 1.238 5.404 5.351 5.404 5.351 1.317-.812 2.422-1.312 3.713-1.792v-6.302zm-10.524 12.662c-.158.459-.618 1.001-.953 1.455.297.235.608.334.882.334.717 0 1.188-.671.542-1.318l-.471-.471zm6.506-3.463c-1.07-1.055-4.732-4.667-5.803-5.713-.165-.161-.421-.18-.608-.044-.639.464-2.082 1.485-2.944 1.788-1.685.59-3.115-.222-3.422-1.359-.192-.712.093-1.411.727-1.781 1.008-.589 1.657-1.375 2.456-2.363-.695-.539-1.35-.732-1.991-.732-1.706 0-3.317 1.366-5.336 1.231-1.373-.09-3.061-.403-3.061-.403v6.333c1.476.321 2.455.464 3.92 1.199l.462-.624c.364-.496.949-.792 1.564-.792.87 0 1.622.578 1.861 1.388.951 0 1.667.602 1.898 1.387.826-.031 1.641.519 1.897 1.385 1.171 0 2.017.92 1.981 2.007l1.168 1.168c.367.368.963.367 1.331 0 .368-.368.368-.964 0-1.332l-1.686-1.687c-.22-.22.113-.553.333-.333l2.032 2.033c.368.368.963.368 1.331 0s.368-.963 0-1.331l-2.501-2.502c-.221-.218.113-.553.333-.333l2.7 2.701c.368.368.963.368 1.331 0 .358-.356.361-.922.027-1.291z"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text">
                                            {formatPrice(
                                                Math.round(
                                                    customer.partnerCost * 100,
                                                ) / 100,
                                                customer.currency,
                                            )}
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="hover-tooltip">
                                            <div className="text">
                                                Extrakostnader
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M17 12c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.687 6-6-2.687-6-6-6zm.5 8.474v.526h-.5v-.499c-.518-.009-1.053-.132-1.5-.363l.228-.822c.478.186 1.114.383 1.612.27.574-.13.692-.721.057-1.005-.465-.217-1.889-.402-1.889-1.622 0-.681.52-1.292 1.492-1.425v-.534h.5v.509c.362.01.768.073 1.221.21l-.181.824c-.384-.135-.808-.257-1.222-.232-.744.043-.81.688-.29.958.856.402 1.972.7 1.972 1.773.001.858-.672 1.315-1.5 1.432zm1.624-10.179c1.132-.223 2.162-.626 2.876-1.197v.652c0 .499-.386.955-1.007 1.328-.581-.337-1.208-.6-1.869-.783zm-2.124-5.795c2.673 0 5-1.007 5-2.25s-2.327-2.25-5-2.25c-2.672 0-5 1.007-5 2.25s2.328 2.25 5 2.25zm.093-2.009c-.299-.09-1.214-.166-1.214-.675 0-.284.334-.537.958-.593v-.223h.321v.211c.234.005.494.03.784.09l-.116.342c-.221-.051-.467-.099-.708-.099l-.072.001c-.482.02-.521.287-.188.399.547.169 1.267.292 1.267.74 0 .357-.434.548-.967.596v.22h-.321v-.208c-.328-.003-.676-.056-.962-.152l.147-.343c.244.063.552.126.828.126l.208-.014c.369-.053.443-.3.035-.418zm-11.093 13.009c1.445 0 2.775-.301 3.705-.768.311-.69.714-1.329 1.198-1.899-.451-1.043-2.539-1.833-4.903-1.833-2.672 0-5 1.007-5 2.25s2.328 2.25 5 2.25zm.093-2.009c-.299-.09-1.214-.166-1.214-.675 0-.284.335-.537.958-.593v-.223h.321v.211c.234.005.494.03.784.09l-.117.342c-.22-.051-.466-.099-.707-.099l-.072.001c-.482.02-.52.287-.188.399.547.169 1.267.292 1.267.74 0 .357-.434.548-.967.596v.22h-.321v-.208c-.329-.003-.676-.056-.962-.152l.147-.343c.244.063.552.126.828.126l.208-.014c.368-.053.443-.3.035-.418zm4.003 8.531c-.919.59-2.44.978-4.096.978-2.672 0-5-1.007-5-2.25v-.652c1.146.918 3.109 1.402 5 1.402 1.236 0 2.499-.211 3.549-.611.153.394.336.773.547 1.133zm-9.096-3.772v-.651c1.146.917 3.109 1.401 5 1.401 1.039 0 2.094-.151 3.028-.435.033.469.107.926.218 1.37-.888.347-2.024.565-3.246.565-2.672 0-5-1.007-5-2.25zm0-2.5v-.652c1.146.918 3.109 1.402 5 1.402 1.127 0 2.275-.176 3.266-.509-.128.493-.21 1.002-.241 1.526-.854.298-1.903.483-3.025.483-2.672 0-5-1.007-5-2.25zm11-11v-.652c1.146.918 3.109 1.402 5 1.402 1.892 0 3.854-.484 5-1.402v.652c0 1.243-2.327 2.25-5 2.25-2.672 0-5-1.007-5-2.25zm0 5v-.652c.713.571 1.744.974 2.876 1.197-.661.183-1.287.446-1.868.783-.622-.373-1.008-.829-1.008-1.328zm0-2.5v-.651c1.146.917 3.109 1.401 5 1.401 1.892 0 3.854-.484 5-1.401v.651c0 1.243-2.327 2.25-5 2.25-2.672 0-5-1.007-5-2.25z"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text">
                                            {formatPrice(
                                                Math.round(
                                                    customer.extrasCost * 100,
                                                ) / 100,
                                                customer.currency,
                                            )}
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="hover-tooltip">
                                            <div className="text">
                                                Total kostnad
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M4 22v-20h16v11.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-14.386h-20v24h10.189c3.163 0 9.811-7.223 9.811-9.614zm-5-1.386h-10v-1h10v1zm0-4h-10v1h10v-1zm0-3h-10v1h10v-1z"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text">
                                            {formatPrice(
                                                Math.round(
                                                    customer.totalCost * 100,
                                                ) / 100,
                                                customer.currency,
                                            )}
                                        </div>
                                    </div>
                                    <div className="divider"></div>
                                    <div className="item">
                                        <div className="hover-tooltip">
                                            <div className="text">
                                                Kundens pris
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M10.81 11.885h-1.098l.066-.739h1.069l-.037.739zm.613 1.099h1.14l-.007-.739h-1.111l-.022.739zm.085-2.971l-.021.739h1.054l-.007-.739h-1.026zm-1.894 2.971h1.14l.038-.739h-1.112l-.066.739zm1.291-2.971h-1.026l-.066.739h1.054l.038-.739zm6.308 0l.137.739h1.054l-.165-.739h-1.026zm-4.115 0l.023.739h1.054l-.051-.739h-1.026zm1.155 1.872l-.051-.739h-1.069l.022.739h1.098zm3.309-4.885h-7.406l-.204 2h8.058l-.448-2zm-6.107 4.885h1.097l-.007-.739h-1.069l-.021.739zm2.874 1.099l-.051-.739h-1.111l.023.739h1.139zm-5.888-2.971h-1.025l-.134.739h1.054l.105-.739zm10.215 1.872l-.165-.739h-1.069l.136.739h1.098zm-12.074-.739h-1.069l-.179.739h1.097l.151-.739zm.231-1.133h-1.026l-.179.739h1.054l.151-.739zm17.187 4.987v7h-24v-7h24zm-2 2h-20v3h20v-3zm-9 1h-2v1h2v-1zm-7.932-5.016h1.14l.15-.739h-1.111l-.179.739zm11.702-2.233l-.121-.739h-1.026l.093.739h1.054zm.185 1.134l-.121-.739h-1.069l.093.739h1.097zm1.946 1.099l-.165-.739h-2.833l.093.739h2.905zm-10.622-1.838h-1.069l-.134.739h1.098l.105-.739zm-1.402 1.838h1.139l.105-.739h-1.11l-.134.739zm-5.595.016l2.621-9h1.921c.112-.622.322-1.371.668-2h3.427c-.26.57-.499 1.259-.627 2h10.805l2.592 9h-2.221l-1.804-7h-9.42c.071.836.178 1.511-.107 2h-3.456c.292-.431.166-1.111.086-2h-.481l-1.739 7h-2.265zm5.101-6.631h2.298c-.157-1.076-.092-2.782.404-3.786h-2.249c-.553 1.006-.624 2.64-.453 3.786z"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text">
                                            {formatPrice(
                                                Math.round(
                                                    customer.customerPrice *
                                                        100,
                                                ) / 100,
                                                customer.currency,
                                            )}
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="hover-tooltip">
                                            <div className="text">Vinst</div>
                                        </div>
                                        <div className="icon">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 3c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm1 13.947v1.053h-1v-.998c-1.035-.018-2.106-.265-3-.727l.455-1.644c.956.371 2.229.765 3.225.54 1.149-.26 1.385-1.442.114-2.011-.931-.434-3.778-.805-3.778-3.243 0-1.363 1.039-2.583 2.984-2.85v-1.067h1v1.018c.725.019 1.535.145 2.442.42l-.362 1.648c-.768-.27-1.616-.515-2.442-.465-1.489.087-1.62 1.376-.581 1.916 1.711.804 3.943 1.401 3.943 3.546.002 1.718-1.344 2.632-3 2.864z"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text">
                                            {formatPrice(
                                                Math.round(
                                                    customer.earnings * 100,
                                                ) / 100,
                                                customer.currency,
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {!!alreadyInvoicedTrackingNumbers.length && (
                <div className="deviations">
                    <div className="title">
                        Försändelsenummer som redan fakturerats för
                    </div>
                    <div className="numbers">
                        {alreadyInvoicedTrackingNumbers.map((number) => {
                            return (
                                <div className="number" key={number}>
                                    {number}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            {!!missingOrders.length && (
                <div className="notFound">
                    <div className="title">
                        Försändelser som inte hittades i systemet
                    </div>
                    <div className="grid">
                        <div className="cell title">Trackingnummer</div>
                        <div className="cell title">Avsändare</div>
                        <div className="cell title"></div>
                        <div className="cell title">Mottagare</div>
                        {missingOrders.map((order) => {
                            return (
                                <Fragment key={order.trackingNumber}>
                                    <div className="cell">
                                        {order.trackingNumber}
                                    </div>
                                    <div className="cell">
                                        {order.senderCompany}
                                    </div>
                                    <div className="cell">-></div>
                                    <div className="cell">
                                        {order.receiverCompany}
                                    </div>
                                </Fragment>
                            );
                        })}
                    </div>
                </div>
            )}
            {(specificationPreview || loadingSpecification) && (
                <div className="preview">
                    {specificationPreview && (
                        <div
                            className="imageContainer"
                            onClick={() => {
                                setSpecificationPreview(null);
                            }}
                        >
                            <img
                                src={`data:image/png;base64, ${specificationPreview}`}
                                alt="Specifikation"
                            />
                        </div>
                    )}
                    {!specificationPreview && <Loader />}
                </div>
            )}
        </Container>
    );
}

export default View;
